import { type PageId } from "../../../config/pages";
import { type CategoryContext, type CategoryItemContext } from "../../../types";

export function getCategoryItemsByPageId(category: CategoryContext, pages: PageId[]): CategoryItemContext[] {
  return category.items.filter((item) => pages.includes(item.pageId));
}
